interface IProps {
  haslivechat: boolean;
  livechat: number;
}

export const register = (props: IProps) => {
  if (!props.haslivechat) {
    return;
  }

  const liveChat = (window as any).__lc || {};
  liveChat.license = props.livechat;
  liveChat.chat_between_groups = false;
  (window as any).__lc = liveChat;

  const liveChatScript = document.createElement('script');
  liveChatScript.type = 'text/javascript';
  liveChatScript.async = true;

  liveChatScript.onload = () => {
    (window as any)?.LC_API?.open_chat_window();
  };

  liveChatScript.src =
    ('https:' === document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js';

  return liveChatScript;
};

export const unregister = (props: IProps) => {
  if (!props.haslivechat) {
    return;
  }

  if ((window as any).LC_API.hide_chat_window) (window as any)?.LC_API?.hide_chat_window();
  if ((window as any).LC_API.close_chat) (window as any)?.LC_API?.close_chat();

  delete (window as any).LC_API;
  delete (window as any).__lc;
  delete (window as any).__lc_inited;
};
